var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/welcome3.96749ea5.png","uri@2x": __webpack_public_path__ + "static/media/welcome3.120df366.png","uri@3x": __webpack_public_path__ + "static/media/welcome3.a7963716.png",
    width: 201,
    height: 201
});